export default __webpack_public_path__ + "static/realization_1-dea3920365a2fe9f9fd851a70ab02de9.jpg";